import angular from 'angular';

// Libraries
import uiModal from 'angular-ui-bootstrap/src/modal';

// Dependencies
import '../../../../../lib/service';

// Translations
import translate from '../../../../../lib/translation';

// Controller
import ImageModalController from './imageModal.controller';
import template from './imageModal.html';

const moduleName = 'staff.dashboardScreen.imageModal';
let module = angular.module(moduleName, [
  uiModal,
  translate
]);

module.controller('ImageModalController', ImageModalController);

module.factory('imageModal', ['$uibModal', ($uibModal) => {
  return props => {
    let modal = $uibModal.open({
      animate: false,
      template: template,
      controller: ImageModalController,
      controllerAs: 'vm',
      size: 'lg',
      resolve: {
        image: () => props.image,
      }
    });
    return modal.result;
  };
}]);

export default module;
